import { Taxonomies } from "./Taxonomies";
import { SpecialtyGroup, Specialty, Taxonomy } from "./taxonomy";


export {
  SpecialtyGroup,
  Specialty,
  Taxonomy,
  Taxonomies
};
